/*
  ui_demo.js
*/

// for the circle
const frames = [];
const totalFrames = 165;


/* VARIABLES */
let arpMode = 0;
let tempoSync = true;
let prevStep = [];
let GUI_Tab = 0;
let loaded = 0;
let blurTimeout;
let UI_status = 0; // 0 if UI hasn't been initiated by clicking or playing a demo


/*
///////////////////////////////////////////////////////////////////
///// INIT DATA
///////////////////////////////////////////////////////////////////
*/

function initUIData() {
	document.getElementById('UI-box').style.backgroundImage = 'url("https://cdn.shopify.com/s/files/1/0452/8911/1710/files/UI_background_'+instrument+'.jpg?quality=100")';
	leftCount = 18;
	rightCount = 622;

	UITabs = document.getElementsByClassName('UI-tab');
	UITabGap = document.getElementById('UI-tabs').dataset.gap;
	if(!isNaN(UITabGap)) UITabGap = 70; else UITabGap = parseInt(UITabGap);

	for(i=0;i<UITabs.length;i++) {
		const currentAlign = UITabs[i].dataset.align;
		if(currentAlign == 'right') {
			UITabs[i].style.left = rightCount+'px';
			rightCount -= UITabGap;
		} else if(currentAlign == 'center') {
			UITabs[i].style.left = '50%';
			UITabs[i].style.transform = 'translateX(-50%)';
		} else {
			UITabs[i].style.left = leftCount+'px';
			leftCount += UITabGap;
		}
	}
}

/*
///////////////////////////////////////////////////////////////////
///// TAB SYSTEM
///////////////////////////////////////////////////////////////////
*/
if(document.getElementById('UI-tab-main'))
  document.getElementById('UI-tab-main').addEventListener('click', (e) => {
  	hideAllTabs();
  	document.getElementById('UI-block-main').style.visibility = 'visible';
  	$('#UI-tab-main').addClass('UI-tab-selected');
  	GUI_Tab = 0;
  	hideUITitle();
  	blurTransition();
  	updateUIPlayerIDs(0);
  });

if(document.getElementById('UI-tab-settings'))
	document.getElementById('UI-tab-settings').addEventListener('click', (e) => {
		hideAllTabs();
		document.getElementById('UI-block-settings').style.visibility = 'visible';
		$('#UI-tab-settings').addClass('UI-tab-selected');
		GUI_Tab = 1;
		hideUITitle();
		blurTransition();
		updateUIPlayerIDs(10);
	});

if(document.getElementById('UI-tab-loop'))
	document.getElementById('UI-tab-loop').addEventListener('click', (e) => {
		hideAllTabs();
		document.getElementById('UI-block-loop').style.visibility = 'visible';
		$('#UI-tab-loop').addClass('UI-tab-selected');
		GUI_Tab = 2;
		blurTransition();
		hideUITitle();
		updateUIPlayerIDs(20);
	});

if(document.getElementById('UI-tab-plugins'))
	document.getElementById('UI-tab-plugins').addEventListener('click', (e) => {
		hideAllTabs();
		document.getElementById('UI-block-plugins').style.visibility = 'visible';
		$('#UI-tab-plugins').addClass('UI-tab-selected');
		GUI_Tab = 3;
		blurTransition();
		hideUITitle();
		updateUIPlayerIDs(30);
	});

if(document.getElementById('UI-tab-mixer'))
	document.getElementById('UI-tab-mixer').addEventListener('click', (e) => {
		hideAllTabs();
		document.getElementById('UI-block-mixer').style.visibility = 'visible';
		$('#UI-tab-mixer').addClass('UI-tab-selected');
		GUI_Tab = 4;
		blurTransition();
		hideUITitle();
		updateUIPlayerIDs(40);
	});

/* HIDE THE SECTION TITLE */
function hideUITitle() {
}

function hideUnnecessaryElements() {
	if(instrument == "piano") {

	}
}

/* UPDATE MUSIC PLAYER IDs */
function updateUIPlayerIDs(index) {
	for(let i=0;i<6;i++) {
		$('#audio-logo-mini-round-' + (i+100)).data('id', index + i);
	}
	/* STOP MUSIC PLAYER IF NECESSARY */
	if(audioPlaying >= 100) 
		playAudio(audioPlaying, originPlaying);
}

/*
///////////////////////////////////////////////////////////////////
///// INIT GUI BY CLICKING OR PLAYING A DEMO
///////////////////////////////////////////////////////////////////
*/

document.getElementById('UI-box').addEventListener('click', (e) => {
	initUI();
});
document.getElementById('UI-float').addEventListener('click', (e) => {
	initUI();
});

/* Save the init status for this session, so users don't have to init again if they reload the website */
$(document).ready(function() {
	let read_UI_status = sessionStorage.getItem("UI_status");
	if(read_UI_status == "1") {
		initUI();
	}
});

function initUI() {
	if(UI_status < 1) {
		UI_status = 1;
		sessionStorage.setItem("UI_status", "1");
		document.getElementById('UI-box').style.filter = 'blur(0)';
		document.getElementById('UI-float').style.opacity = '0';
		document.getElementById('UI-float').style.visibility = 'hidden';
	}
}

/*
///////////////////////////////////////////////////////////////////
///// UI MUSIC ANIMATION
///////////////////////////////////////////////////////////////////
*/

/*
///////////////////////////////////////////////////////////////////
///// BLUR TRANSITION
///////////////////////////////////////////////////////////////////
*/

function blurTransition() {
	if(document.getElementById('UI-info-left')) {
		const infoLeft = document.getElementById('UI-info-left');
		const infoRight = document.getElementById('UI-info-right');
		clearTimeout(blurTimeout);
		infoLeft.style.filter = 'blur(10px)';
		infoLeft.style.opacity = '0';
		infoRight.style.filter = 'blur(10px)';
		infoRight.style.opacity = '0';
		blurTimeout = setTimeout(() => {
	    	updateGUIInfo();
			infoLeft.style.opacity = '1';
			infoRight.style.opacity = '1';
	        infoLeft.style.filter = 'blur(0px)';
	        infoRight.style.filter = 'blur(0px)';
	    }, 500);
	}
}



const GUI_InfoTitles = {};
GUI_InfoTitles['mallets'] = [[
	'Control the distance',
	'Shape Your Sound',
	'Arpeggiator',
	'Plugin Control',
	'Mixer'
],
[
	'Control the timbre',
	'',
	'Flexible Tempo',
	'Vibraphone Motor',
	''
]];

const GUI_InfoTexts = {};
GUI_InfoTexts['mallets'] = [[
	'The slider on top controls the position the instrument within your space, with stunning precision, from close and intimate, to lush and orchestral, to distant and atmospheric.',
	'The instruments\' settings let you shape the expressivity of the sound, from making a quantised performance come to life (Tightness), to emulating the resonances of a physical instrument (Interferences). The AHDS(R) settings open countless possibilities for more experimental settings.',
	'Our sequencer and arpeggiator were designed as powerful tools to boost your inspiration: They create and perform complex patterns by simply pressing a single note or chord, making the creative process absurdly fast, easy and fun. The smart preset buttons generate infinite possibilities for each setting, allowing you to explore countless shapes with one click.',
	'The main acoustic patches each include three plugins: Delay, Detune, as well as a beautifully delicate Reverb space that sounds as if the notes were suspended mid air.<br/>The Synth additionally features Tape, Pulse, Vibrato and EQ for maximum control over the sound.',
	'The three microphone positions and two rendered outboard reverbs complement each other and form a flexible palette.'
],
[
	'The timbre slider on the bottom lets you control the hardness of the mallets with nearly infinite and seamless colours, from soft (left) to hard (right), allowing for hyper-realistic performance effects, such as fluidly changing the mallets material while playing.<br/>In the synth, this slider controls the warmth and distortion of the sound.',
	'',
	'The unique flexible tempo mode lets you break free from the DAW\'s fixed tempo, opening up a whole new world of idiomatic playing and expressive rubato performances. Again, simply by pressing a single chord.',
	'The vibraphone additionally features a tremolo plugin, a perfect emulation of the physical instruments\' motor, modulating both volume, pitch and the sound spectrum, as well as reacting to the position in the room. Both the speed and the intensity can be modulated, going one step further than the physical instruments\' capabilities by allowing a seamless fadein or fadeout of the effect.',
	''
]];

const GUI_InfoTrackTitles = {};
GUI_InfoTrackTitles['mallets'] = [
	[ 'MARIMBA', 'VIBRAPHONE', 'MARIMBA<br/>Mute', 'MARIMBA', 'VIBRAPHONE', 'SYNTH ARP<br/>Death Valley'],
	[ 'MARIMBA', 'MARIMBA<br/>Mute', 'SYNTH ARP<br/>Nightshade', '', '', ''],
	[ 'SYNTH', 'VIBRAPHONE<br/>Mute', 'MARIMBA', 'MARIMBA', 'SYNTH ARP<br/>Ethereal Dreams', 'MARIMBA'],
	[ 'MARIMBA<br/>Reverb Plugin', 'VIBRAPHONE<br/>Detune Plugin', '', 'VIBRAPHONE<br/>Tremolo Plugin', 'VIBRAPHONE<br/>Tremolo Plugin', ''],
	[ '', '', '', '', '', '']
];

/* TAB SYSTEM FOR INFO LEFT AND RIGHT */
function updateGUIInfo() {
	if(document.getElementById('UI-info-title-left')) {
		document.getElementById('UI-info-title-left').innerHTML = GUI_InfoTitles[instrument][0][GUI_Tab];
		document.getElementById('UI-info-title-right').innerHTML = GUI_InfoTitles[instrument][1][GUI_Tab];
		document.getElementById('UI-info-text-left').innerHTML = GUI_InfoTexts[instrument][0][GUI_Tab];
		document.getElementById('UI-info-text-right').innerHTML = GUI_InfoTexts[instrument][1][GUI_Tab];

		let side = 0;
		for(let i=0;i<6;i++) {
			const trackTitle = GUI_InfoTrackTitles[instrument][GUI_Tab][i];

			if(trackTitle == "") {
				document.getElementById('audio-demo-mini-round-'+(i+100)).style.display = 'none';
			} else {	
				document.getElementById('audio-title-track-'+(i+100)).innerHTML = trackTitle;
				document.getElementById('audio-demo-mini-round-'+(i+100)).style.display = 'block';
			}
		}
	}
}

/*
///////////////////////////////////////////////////////////////////
///// HIDE ALL TABS
///////////////////////////////////////////////////////////////////
*/
function hideAllTabs() {
	for(let i=0;i<UIBlocks.length;i++) {
		UIBlocks[i].style.visibility = 'hidden';
	}
	$('.UI-tab').removeClass('UI-tab-selected');
}





/*
///////////////////////////////////////////////////////////////////
///// SLIDER & KNOB CONTROLS
///////////////////////////////////////////////////////////////////
*/

const UIBox = document.getElementsByClassName('UI-box')[0];
const UIsliderTop = document.getElementById('UI-slider-main-top');
const UIsliderBottom = document.getElementById('UI-slider-main-bottom');

const UIUISlidersettings1 = document.getElementById('UI-settings-slider1');
const UIUISlidersettings2 = document.getElementById('UI-settings-slider2');
const UIUISlidersettings3 = document.getElementById('UI-settings-slider3');

const UIsliderLoop1 = document.getElementById('UI-loop-slider1');
const UIsliderLoop2 = document.getElementById('UI-loop-slider2');

const UICircle = document.getElementsByClassName('UI-circle')[0];
const UICircle_canvas = UICircle.getContext('2d');
const UIBlocks = document.getElementsByClassName('UI-block');

const UISliderTotalFrames = 165;
const UIUISlidersmallTotalFrames = 101;
const UIUISlidersmallestTotalFrames = 101;
const UIKnobTotalFrames = 103;
const UIPanTotalFrames = 70;
const UISliderMixerTotalFrames = 101;
const knobSensitivity = 0.5;
const UIsliderFrameHeight = 72;
const UISliderMixerFrameHeight = 183;
const UIUISlidersmallFrameHeight = 34;
const UIUISlidersmallestFrameHeight = 27;
const UIKnobFrameHeight = 53;
const UIPanFrameHeight = 56;
const UIsliderTrackLeftPct = 50.156 / 281.167;
const UIsliderTrackWidthPct = (281.167 - 50.156 * 2) / 281.167;

var UISliders = [];

UISliders.push({ el: UIsliderTop, frames: UISliderTotalFrames, frameH: UIsliderFrameHeight, defaultFrame: 80 });
UISliders.push({ el: UIsliderBottom, frames: UISliderTotalFrames, frameH: UIsliderFrameHeight, defaultFrame: 164 });

var slidersSmall = document.getElementsByClassName('UI-slider-small');
for(i=0;i<slidersSmall.length;i++) {
	UISliders.push({ el: slidersSmall[i], frames: UIUISlidersmallTotalFrames, frameH: UIUISlidersmallFrameHeight, defaultFrame: slidersSmall[i].dataset.default });
}

var slidersArp = document.getElementsByClassName('UI-loop-slider');
for(i=0;i<slidersArp.length;i++) {
	UISliders.push({ el: slidersArp[i], frames: UIUISlidersmallestTotalFrames, frameH: UIUISlidersmallestFrameHeight, defaultFrame: slidersArp[i].dataset.default });
}


var knobs = [];
var UIKnobsElements = document.getElementsByClassName('UI-knob');
for(i=0;i<UIKnobsElements.length;i++) {
	knobs.push ( { el: UIKnobsElements[i], defaultFrame: parseInt(UIKnobsElements[i].dataset.default) } );
}

var pans = [];
var UIPansElements = document.getElementsByClassName('UI-slider-pan');

for(i=0;i<UIPansElements.length;i++) {
	pans.push ( { el: UIPansElements[i], defaultFrame: parseInt(UIPansElements[i].dataset.default) } );
}

var mixers = [];
var UIMixerElements = document.getElementsByClassName('UI-slider-vertical');
for(i=0;i<UIMixerElements.length;i++) {
	mixers.push ( { el: UIMixerElements[i], defaultFrame: parseInt(UIMixerElements[i].dataset.default) } );
}

UISliders.forEach(s => {
  s.el.isDragging = false;
  s.el.style.backgroundPosition = `0 ${-s.defaultFrame * s.frameH}px`;
  s.el.addEventListener('mousedown', () => s.el.isDragging = true);
});

knobs.forEach(k => {
  k.el.isDragging = false;
  k.el.currentFrame = k.defaultFrame;
  k.el.startFrame = k.defaultFrame;
  k.el.startY = 0;
  k.el.style.backgroundPosition = `0 ${-k.defaultFrame * UIKnobFrameHeight}px`;
  k.el.addEventListener('mousedown', (e) => {
    k.el.isDragging = true;
    k.el.startY = e.screenY;
    k.el.startFrame = k.el.currentFrame;
  });
});

pans.forEach(k => {
  k.el.isDragging = false;
  k.el.currentFrame = k.defaultFrame;
  k.el.startFrame = k.defaultFrame;
  k.el.startY = 0;
  k.el.style.backgroundPosition = `0 ${-k.defaultFrame * UIPanFrameHeight}px`;
  k.el.addEventListener('mousedown', (e) => {
    k.el.isDragging = true;
    k.el.startY = e.screenY;
    k.el.startFrame = k.el.currentFrame;
  });
});

mixers.forEach(m => {
  m.el.isDragging = false;
  m.el.addEventListener('mousedown', () => m.el.isDragging = true);
});

// MOUSEUP
document.addEventListener('mouseup', () => {
  UISliders.forEach(s => s.el.isDragging = false);
  knobs.forEach(k => k.el.isDragging = false);
  pans.forEach(k => k.el.isDragging = false);
  mixers.forEach(m => m.el.isDragging = false);
});

// MOUSEMOVE
document.addEventListener('mousemove', (e) => {
  UISliders.forEach(s => {
    if (!s.el.isDragging || audioPlaying > -1) return;
    const rect = s.el.getBoundingClientRect();
    const trackLeft = rect.width * UIsliderTrackLeftPct;
    const trackWidth = rect.width * UIsliderTrackWidthPct;
    const x = e.clientX - rect.left - trackLeft;
    const frame = Math.min(s.frames - 1, Math.max(0, Math.floor((x / trackWidth) * s.frames)));
    // s.el.style.backgroundPosition = `0 ${-frame * s.frameH}px`;
    updateUISliderPosition(s, frame);
    if (s.el === UIsliderTop) {
    	hideUITitle();
    } else if (s.el === UIsliderBottom) {
    	hideUITitle();
    } 
  });

  knobs.forEach(k => {
    if (!k.el.isDragging || audioPlaying > -1) return;
    const delta = k.el.startY - e.screenY;
    k.el.currentFrame = Math.min(UIKnobTotalFrames - 1, Math.max(0, Math.floor(k.el.startFrame + delta / knobSensitivity)));
    updateUIKnobPosition(k, k.el.currentFrame);
  });

  pans.forEach(k => {
    if (!k.el.isDragging || audioPlaying > -1) return;
    const delta = k.el.startY - e.screenY;
    k.el.currentFrame = Math.min(UIPanTotalFrames - 1, Math.max(0, Math.floor(k.el.startFrame + delta / knobSensitivity)));
    k.el.style.backgroundPosition = `0 ${-k.el.currentFrame * UIPanFrameHeight}px`;
  });

  mixers.forEach(m => {
    if (!m.el.isDragging || audioPlaying > -1) return;
    const rect = m.el.getBoundingClientRect();
    const trackLeft = rect.top * UIsliderTrackLeftPct;
    const trackWidth = rect.top * (UIsliderTrackWidthPct - 0.433);
    const x = e.clientY - rect.top - trackLeft / 2;
    const frame = Math.min(UISliderMixerTotalFrames - 1, Math.max(0, Math.floor(((trackWidth - x) / trackWidth) * UISliderMixerTotalFrames)));
    updateUIMixerPosition(m, frame);
  });
});

/* UPDATE UI ELEMENTS */
function mixerDefault() {
	for(i=0;i<mixers.length;i++) {
		updateUIMixerPosition(mixers[i], mixers[i].defaultFrame);
	}
}
function updateLoopSpeed(frame) {
	let frameDiv = Math.floor(frame / 20);
    if (frameDiv > 4) frameDiv = 4;
    document.getElementById('UI-loop-options4').innerHTML = [0.25, 0.5, 1, 2, 4][frameDiv] + 'X';
}
function updateUIMixerPosition(mixer, frame) {
	mixer.el.style.backgroundPosition = `-76px ${-frame * UISliderMixerFrameHeight}px`;
}
function updateUIKnobPosition(knob, frame) {
	knob.el.style.backgroundPosition = `0 ${-frame * UIKnobFrameHeight}px`;
}
function updateUISliderPosition(slider, frame) {
	slider.el.style.backgroundPosition = `0 ${-frame * slider.frameH}px`;
	if(slider.el === UIsliderTop)
		updateUICircleDistance(frame);
	if(slider.el === UIsliderBottom)
		updateUICircleTimbre(frame);
	if(slider.el === UIsliderLoop2) {
      updateLoopSpeed(frame);
    }
}
function updateUICircleDistance(frame) {
	UICircle.style.filter = `blur(${(165 - frame) / 20.0}px)`;
}
function updateUICircleTimbre(frame) {
	const f = Math.min(frame + 1, 164);
	// UICircle.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/circle_${165 - f}.png')`;
	UICircle_canvas.clearRect(0, 0, 366, 366);
	UICircle_canvas.drawImage(frames[165 - f], 0, 0, 244, 244);
}

/*
///////////////////////////////////////////////////////////////////
///// RESET UI ELEMENT (CMD+Click)
///////////////////////////////////////////////////////////////////
*/
document.addEventListener('click', (e) => {
  if (!e.metaKey) return;

  const s = UISliders.find(s => s.el === e.target);
  if (s) {
    s.el.style.backgroundPosition = `0 ${-s.defaultFrame * s.frameH}px`;
    if (s.el === UIsliderTop) UICircle.style.filter = `blur(${(165 - s.defaultFrame) / 20.0}px)`;
    if (s.el === UIsliderBottom) {
      const f = Math.min(s.defaultFrame + 1, 164);
      UICircle.style.backgroundImage = `url('https://cdn.shopify.com/s/files/1/0452/8911/1710/files/circle_${165 - f}.png')`;
    }
    if (s.el === UIsliderLoop2) {
      let frameDiv = Math.floor(s.defaultFrame / 20);
      if (frameDiv > 4) frameDiv = 4;
      document.getElementById('UI-loop-options4').innerHTML = [0.25, 0.5, 1, 2, 4][frameDiv] + 'X';
    }
  }

  const k = knobs.find(k => k.el === e.target);
  if (k) {
    k.el.currentFrame = k.defaultFrame;
    k.el.style.backgroundPosition = `0 ${-k.defaultFrame * UIKnobFrameHeight}px`;
  }

  const p = pans.find(p => p.el === e.target);
  if (p) {
    p.el.currentFrame = p.defaultFrame;
    p.el.style.backgroundPosition = `0 ${-p.defaultFrame * UIPanFrameHeight}px`;
  }

  const m = mixers.find(m => m.el === e.target);
  if (m) {
    m.el.currentFrame = m.defaultFrame;
    m.el.style.backgroundPosition = `-76px ${-m.defaultFrame * UISliderMixerFrameHeight}px`;
  }
});





/* TURN PLUGIN ON AND OFF */
$('.UI-plugin-on').on('click', function() {
    // $(this).parent().toggleClass('UI-plugin-active');
});

/*
///////////////////////////////////////////////////////////////////
///// PRELOAD CIRCLE
///////////////////////////////////////////////////////////////////
*/
async function preloadCircle() {
	/*for (let i = 1; i < totalFrames; i++) {
	  const img = new Image();
	  img.onload = () => {
	    loaded++;
	    if (loaded === totalFrames) drawFrame(0);
	  };
	  img.src = `https://cdn.shopify.com/s/files/1/0452/8911/1710/files/circle_${i}.png`;
	  frames.push(img);
	}*/
	const promises = [];
  for (let i = 1; i <= 164; i++) {
    promises.push(
      fetch(`https://cdn.shopify.com/s/files/1/0452/8911/1710/files/circle_${i}.png`)
        .then(r => r.blob())
        .then(createImageBitmap)
        .then(bitmap => { frames[i] = bitmap; })
    );
  }
  await Promise.all(promises);
  await UICircle_canvas.drawImage(frames[1], 0, 0, 244, 244);
}


/*
///////////////////////////////////////////////////////////////////
///// UPDATE CANVAS SIZE
///////////////////////////////////////////////////////////////////
*/
function updateUIScale() {
  let scale;
  if(!isMobile)
    scale = Math.min(window.innerWidth / 712, window.innerHeight / 603) * 0.7;
  else 
   scale = Math.min(window.innerWidth / 712, window.innerHeight / 603) * 0.9;
  UIBox.style.transform = `scale(${scale})  translateX(-50%)`;
  UIBox.style.transformOrigin = 'top left';
}


/*
///////////////////////////////////////////////////////////////////
///// ARPEGGIATOR: Functions
///////////////////////////////////////////////////////////////////
*/

/* init parameter forces the arp to update the page even if audio is playing */
/* forceSetting forces the tempo sync to turn on or off. Without this parameter, it will simply toggle */

function toggleTempoSync(init=0, forceSetting=-1) {
	if(audioPlaying == -1 || init > 0) {
		if(forceSetting == 0)
			tempoSync = 1;
		else if(forceSetting == 1)
			tempoSync = 0;
		if(tempoSync) {
			tempoSync = false;
			document.getElementById('UI-loop-options-radio3').style.backgroundPosition = "0 -156px";
			document.getElementById('UI-arp-row-time').style.display = 'block';
			document.getElementById('UI-arp-row-rhythm').style.display = 'none';
			document.getElementById('UI-loop-options4').style.display = 'none';
		} else {
			tempoSync = true;
			document.getElementById('UI-loop-options-radio3').style.backgroundPosition = "0 -195px";
			document.getElementById('UI-arp-row-time').style.display = 'none';
			document.getElementById('UI-arp-row-rhythm').style.display = 'block';
			document.getElementById('UI-loop-options4').style.display = 'block';
		}
	}
}

if(document.getElementById('UI-loop-options-radio3'))
	document.getElementById('UI-loop-options-radio3').addEventListener('click', (e) => {
		toggleTempoSync();
	});

/* init parameter forces the arp to update the page even if audio is playing */

function arpeggiatorTurnOff(init=0) {
	if(arpMode != 0 && (audioPlaying == -1 || init > 0)) {
		arpMode = 0;
	
		document.getElementById('UI-loop-radio2').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio2').style.opacity = "0.5";
		document.getElementById('UI-loop-text2').style.opacity = "0.5";
	
		document.getElementById('UI-loop-radio1').style.backgroundPosition = "0 -195px";
		document.getElementById('UI-loop-radio1').style.opacity = "1";
		document.getElementById('UI-loop-text1').style.opacity = "0.8";
	
		document.getElementById('UI-loop-radio3').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio3').style.opacity = "0.5";
		document.getElementById('UI-loop-text3').style.opacity = "0.5";
	
		document.getElementById('UI-arp-grid').style.display = 'none';
		document.getElementById('UI-arp-row-pitch').style.display = 'none';
		document.getElementById('UI-arp-row-step').style.display = 'none';
		toggleRightArpPanel();
	}
}

if(document.getElementById('UI-loop-setting1'))
	document.getElementById('UI-loop-setting1').addEventListener('click', (e) => {
		arpeggiatorTurnOff();
	});

function arpeggiatorLoadStep(init=0) {
	if(arpMode != 1 && (audioPlaying == -1 || init > 0)) {

		arpMode = 1;

		document.getElementById('UI-loop-radio1').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio1').style.opacity = "0.5";
		document.getElementById('UI-loop-text1').style.opacity = "0.5";

		document.getElementById('UI-loop-radio2').style.backgroundPosition = "0 -195px";
		document.getElementById('UI-loop-radio2').style.opacity = "1";
		document.getElementById('UI-loop-text2').style.opacity = "0.8";

		document.getElementById('UI-loop-radio3').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio3').style.opacity = "0.5";
		document.getElementById('UI-loop-text3').style.opacity = "0.5";

		document.getElementById('UI-arp-grid').style.display = 'block';
		document.getElementById('UI-arp-row-pitch').style.display = 'block';
		document.getElementById('UI-arp-row-step').style.display = 'none';
		document.getElementById('UI-arp-label4').innerHTML = 'PITCH';
		toggleRightArpPanel();
	}
}

if(document.getElementById('UI-loop-setting2'))
	document.getElementById('UI-loop-setting2').addEventListener('click', (e) => {
			arpeggiatorLoadStep();
	});


function arpeggiatorLoadArp(init=0) {
	if(arpMode != 2 && (audioPlaying == -1 || init > 0)) {
		arpMode = 2;
		document.getElementById('UI-loop-radio1').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio1').style.opacity = "0.5";
		document.getElementById('UI-loop-text1').style.opacity = "0.5";

		document.getElementById('UI-loop-radio3').style.backgroundPosition = "0 -195px";
		document.getElementById('UI-loop-radio3').style.opacity = "1";
		document.getElementById('UI-loop-text3').style.opacity = "0.8";

		document.getElementById('UI-loop-radio2').style.backgroundPosition = "0 -156px";
		document.getElementById('UI-loop-radio2').style.opacity = "0.5";
		document.getElementById('UI-loop-text2').style.opacity = "0.5";

		document.getElementById('UI-arp-grid').style.display = 'block';
		document.getElementById('UI-arp-row-pitch').style.display = 'none';
		document.getElementById('UI-arp-row-step').style.display = 'block';
		document.getElementById('UI-arp-label4').innerHTML = 'STEP';
		toggleRightArpPanel();
	} 
}

if(document.getElementById('UI-loop-setting3'))
	document.getElementById('UI-loop-setting3').addEventListener('click', (e) => {
		arpeggiatorLoadArp();
	});


function toggleRightArpPanel() {
	let panelVisibility;
	if(arpMode == 0) panelVisibility = 'none';
	else panelVisibility = 'block';
	for(let i=0;i<document.getElementsByClassName('UI-loop-rightpanel').length;i++) {
		document.getElementsByClassName('UI-loop-rightpanel')[i].style.display = panelVisibility;
	}
}


/* RESET ARP ROW */
if(document.getElementById('UI-arp-buttonA1')) {
	document.getElementById('UI-arp-buttonA1').addEventListener('click', (e) => {
		if(!tempoSync)
			resetArpRow(document.getElementById('UI-arp-row-time'),  'UI-arp-row-time','opacity', 0);
		else 
			resetArpRow(document.getElementById('UI-arp-row-rhythm'),  'UI-arp-row-rhythm','note', 0);
	});
	document.getElementById('UI-arp-buttonA2').addEventListener('click', (e) => {
		resetArpRow(document.getElementById('UI-arp-row-velo'), 'UI-arp-row-velo','opacity', 0);
	});
	document.getElementById('UI-arp-buttonA3').addEventListener('click', (e) => {
		resetArpRow(document.getElementById('UI-arp-row-octave'), 'UI-arp-row-octave', 'text', 0);
	});
	document.getElementById('UI-arp-buttonA4').addEventListener('click', (e) => {
		if(arpMode == 1)
			resetArpRow(document.getElementById('UI-arp-row-pitch'), 'UI-arp-row-pitch','text', 0);
		else if(arpMode == 2)
			resetArpRow(document.getElementById('UI-arp-row-step'), 'UI-arp-row-step','step', 0);
	});
	document.getElementById('UI-arp-buttonA5').addEventListener('click', (e) => {
		resetArpRow(document.getElementById('UI-arp-row-pan'), 'UI-arp-row-pan', 'text', 0);
	});
}

function resetArpRow(grid, className, type, defaultValue) {
  grid.querySelectorAll('.' + className).forEach((cell, i) => {
  	if(audioPlaying == -1) {
    	if (type === 'opacity') {
    	  cell.style.opacity = 0.6;
    	} else if (type === 'note') {
    		cell.style.backgroundPosition = "0 -200px";
    	} else if (type === 'step') {
    		if(i<6)
    			cell.textContent = i+1;
    		else 
    			cell.textContent = 'X';
    	}
    	else {
    	  cell.textContent = defaultValue;
    	}
    }
  });
}

/* MAGIC ARP ROW */
if(document.getElementById('UI-arp-buttonB1')) {
	document.getElementById('UI-arp-buttonB1').addEventListener('click', (e) => {
		if(!tempoSync)
			randomArpRow(document.getElementById('UI-arp-row-time'), 'UI-arp-row-time','opacity', 0, 0);
		else 
			randomArpRow(document.getElementById('UI-arp-row-rhythm'), 'UI-arp-row-rhythm','note', 0, 0);
	});
	document.getElementById('UI-arp-buttonB2').addEventListener('click', (e) => {
		randomArpRow(document.getElementById('UI-arp-row-velo'), 'UI-arp-row-velo','opacity', 0, 0);
	});

	document.getElementById('UI-arp-buttonB3').addEventListener('click', (e) => {
		randomArpRow(document.getElementById('UI-arp-row-octave'), 'UI-arp-row-octave','text', -4, 4);
	});
	document.getElementById('UI-arp-buttonB4').addEventListener('click', (e) => {
		if(arpMode == 1)
			randomArpRow(document.getElementById('UI-arp-row-pitch'), 'UI-arp-row-pitch','pitch', 0, 0);
		else 
			randomArpRow(document.getElementById('UI-arp-row-step'), 'UI-arp-row-step','step', 0, 0);
	});
	document.getElementById('UI-arp-buttonB5').addEventListener('click', (e) => {
		randomArpRow(document.getElementById('UI-arp-row-pan'), 'UI-arp-row-pan','pan', 0, 0);
	});
}

function randomArpRow(grid, className, type, min, max) {
	if(audioPlaying == -1) {
		let start;
		let end;
		const linear = Math.random()>0.5? true : false ;
		const currentArp = generateArpPattern();
		const step = generateStepPattern();
		const r = Math.floor(Math.random() * 101);
		const pans = generatePan();
		let size;
		if (r >= 81) size = 4;
		else if (r >= 12) size = 8;
		else size = 16;
		if(Math.random()>0.5) {
			start = Math.random() * 0.3;
			end = Math.random() * 0.5 + 0.5;
		} else {
			end = Math.random() * 0.3;
			start = Math.random() * 0.5 + 0.5;
		}
		const preset = arpPresets[Math.floor(Math.random() * arpPresets.length)];
		grid.querySelectorAll('.' + className).forEach((cell, i) => {
			if (type === 'opacity') {
				if(linear) {
					cell.style.opacity = start + (end - start) * (i < 8 ? i / 8.0 : (16 - i) / 8.0);
				} else {
					cell.style.opacity = Math.random();
				}
			} else if (type === 'note') {
				cell.style.backgroundPosition = "0 "+Math.round(Math.random()*5)*50+"px";
			} else if (type === 'pitch') {
				cell.textContent = currentArp[i % preset.length];
			} else if (type === 'step') {
				const val = step[i];
			    if (val === 'R') cell.textContent = 'R';
			    else if (val === 0) cell.textContent = 'X';
			    else cell.textContent = val;
			} else if (type === 'pan') {
				cell.textContent = pans[i];
			}
			else {
				cell.textContent = Math.floor(Math.random() * (max - min + 1)) + min;
			}
		});
	}
}
let panDirection = 0;
const steps = 16;

function generatePan() {
  const result = new Array(steps);

  if (panDirection === 0) {
    for (let i = 0; i < steps; i++) result[i] = i % 2 === 0 ? -50 : 50;
    panDirection = 1;

  } else if (panDirection === 2) {
    for (let i = 0; i < steps; i++) result[i] = i % 2 === 0 ? 50 : -50;
    panDirection = 3;

  } else if (panDirection === 1) {
    const start = Math.floor(Math.random() * 35) - 50;
    const end = 50 - (start + 50);
    const half = Math.floor(steps / 2);
    for (let i = 0; i < steps; i++) {
      result[i] = Math.round(i <= half
        ? start + i * (end - start) / half
        : end - (i - half) * (end - start) / half);
    }
    panDirection = 2;

  } else if (panDirection === 3) {
    const end = Math.floor(Math.random() * 35) - 50;
    const start = 50 - (end + 50);
    const half = Math.floor(steps / 2);
    for (let i = 0; i < steps; i++) {
      result[i] = Math.round(i <= half
        ? start - i * (start - end) / half
        : end + (i - half) * (start - end) / half);
    }
    panDirection = 0;
  }

  return result;
}
function generateArpPattern() {
  // pick random preset and find its length
  const presetIndex = Math.floor(Math.random() * arpPresets.length);
  const preset = arpPresets[presetIndex];
  const limit = preset.length;

  // build currentArp (16 values) from random slices of preset
  const currentArp = [];
  let prevStartPoint = -1;

  while (currentArp.length < 16) {
    let startPoint = Math.floor(Math.random() * limit);
    while (startPoint === prevStartPoint && limit > 1) {
      startPoint = Math.floor(Math.random() * limit);
    }
    const endPoint = Math.floor(Math.random() * limit) + 1;
    let countc = startPoint;
    while (countc < endPoint && currentArp.length < 16) {
      currentArp.push(preset[countc]);
      prevStartPoint = countc;
      countc++;
    }
  }

  return currentArp;
}
function generateStepPattern() {
  const stepSizeLimit = 6;
  const R = 'R';
  let step = [];

  // keep generating until result differs from previous
  do {
    let size = stepSizeLimit;
    step = new Array(32).fill(0);

    // basic structure: 1,2,3,4,5,6
    for (let i = 0; i < size; i++) step[i] = i + 1;

    // REVERSE — 10% chance
    if (Math.random() * 100 > 90) {
      const temp = [...step];
      for (let i = 0; i < size; i++) step[i] = temp[size - 1 - i];
    }

    // NEGATIVE — 30% chance
    if (Math.random() * 100 > 70) {
      for (let i = 0; i < size; i++) {
        if (step[i] !== R) step[i] *= -1;
      }
    }

    // EVERY SECOND NEGATIVE — 10% chance
    if (Math.random() * 100 > 90) {
      let i = Math.floor(Math.random() * 2);
      while (i < size) {
        if (step[i] !== R) step[i] *= -1;
        i += 2;
      }
    }

    // INTRODUCE Rs — 10% chance
    if (Math.random() * 100 > 90) {
      for (let i = 0; i < size; i++) {
        if (Math.random() * 100 > 90) step[i] = R;
      }
    }

    // RANDOMISE RANDOM STEPS — 10% chance
    if (Math.random() * 100 > 90) {
      for (let i = 0; i < size; i++) {
        if (Math.random() * 100 > 95) step[i] = Math.floor(Math.random() * stepSizeLimit) + 1;
        else if (Math.random() * 100 > 95) step[i] = -(Math.floor(Math.random() * stepSizeLimit) + 1);
      }
    }

    // ZIG ZAG — 10% chance
    if (Math.random() * 100 > 90) {
      const temp = [...step];
      let i = 1;
      while (i < size - 1) {
        step[i] = temp[i + 1];
        step[i + 1] = temp[i];
        i += 2;
      }
    }

    // RANDOM PERMUTATIONS — 10% chance
    if (Math.random() * 100 > 90) {
      const swaps = Math.floor(Math.random() * 4);
      for (let i = 0; i < swaps; i++) {
        const temp = [...step];
        const p1 = Math.floor(Math.random() * size);
        const p2 = Math.floor(Math.random() * size);
        step[p1] = temp[p2];
        step[p2] = temp[p1];
      }
    }

    // RANDOM DOUBLE STEPS — 10% chance
    if (Math.random() * 100 > 90) {
      const doubles = Math.floor(Math.random() * 4);
      for (let i = 0; i < doubles; i++) {
        const temp = [...step];
        const pos = Math.floor(Math.random() * size);
        size++;
        for (let j = pos; j < size; j++) step[j + 1] = temp[j];
      }
    }

    // MIRROR or EXTEND — 10% chance each
    if (Math.random() * 100 > 90) {
      const oldSize = size;
      size *= 2;
      for (let i = oldSize; i < size; i++) {
        step[i] = step[size - 1 - i];
      }
    } else if (Math.random() * 100 > 90) {
      const extend = Math.floor(Math.random() * 4);
      for (let i = size; i < size + extend; i++) {
        step[i] = Math.floor(Math.random() * stepSizeLimit) + 1;
      }
      size += extend;
    }

    // DOUBLE STRIKE — 15% chance
    if (Math.random() * 100 > 85) {
      const temp = [...step];
      size *= 2;
      for (let i = 0; i < size; i += 2) {
        step[i] = temp[Math.floor(i / 2)];
        step[i + 1] = temp[Math.floor(i / 2)];
      }
    }

  } while (step.slice(0, 16).join(',') === prevStep.join(','));

  prevStep = step.slice(0, 16);
  return step;
}

const arpPresets = [
  [0, 3, 7],
  [0, 2, 3, 7],
  [0, 3, 7],
  [0, 3, 7],
  [0, 3, 7],
  [0, 3, 7],
  [-5, 0, 3, 7, 12],
  [-5, 0, 3],
  [7, 3, 0],
  [-5, 0, 3, 7, 12],
  [-5, 0, 3, 7, 12],
  [0, 3, 7, 3],
  [7, 3, 0, 3],
  [0, 3, 7, 8, 7, 3, 0],
  [-12, -5, 0, 3, 7, 3, 0],
  [-5, 0, 3, 7, 12],
  [12, 7, 3, 0, -5],
  [12, 7, 3, 0, -5],
  [12, 7, 3, 0, -5, -12],
  [0, 3, 0, 0, 3, 0, 0, 3],
  [0, 7, 0, 0, 7, 0, 0, 7],
  [0, 5, 0, 0, 5, 0, 0, 5],
  [0, 12, 0, 0, 12, 0, 0, 12],
];

/*
///////////////////////////////////////////////////////////////////
///// ARPEGGIATOR: Load Grid
///////////////////////////////////////////////////////////////////
*/
const UI_arp_tablespacebetween = 30;
function loadArpGrid() {
	let html = '';

	/* NUMBERS */
	const gridNumbers = document.getElementById('UI-arp-row-numbers');
	html = '';
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-number" id="UI-arp-row-numbers-${i}" style="left: ${i*UI_arp_tablespacebetween}px">${i}</div>`;
	}
	gridNumbers.innerHTML = html;

	/* PAN */
	html = '';
	const gridPan = document.getElementById('UI-arp-row-pan');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-pan" id="UI-arp-row-pan-${i}" style="left: ${i*UI_arp_tablespacebetween}px">0</div>`;
	}
	gridPan.innerHTML = html;


	/* OCTAVE */
	html = '';
	const gridOctave = document.getElementById('UI-arp-row-octave');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-octave" id="UI-arp-row-octave-${i}" style="left: ${i*UI_arp_tablespacebetween}px">0</div>`;
	}
	gridOctave.innerHTML = html;


	/* STEP */
	html = '';
	const gridStep = document.getElementById('UI-arp-row-step');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-step" id="UI-arp-row-step-${i}" style="left: ${i*UI_arp_tablespacebetween}px">0</div>`;
	}
	gridStep.innerHTML = html;



	/* PITCH */
	html = '';
	const gridPitch = document.getElementById('UI-arp-row-pitch');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-pitch" id="UI-arp-row-pitch-${i}" style="left: ${i*UI_arp_tablespacebetween}px">0</div>`;
	}
	gridPitch.innerHTML = html;



	/* VELOCITY */
	html = '';
	const gridVelo = document.getElementById('UI-arp-row-velo');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-velo" id="UI-arp-row-velo-${i}" style="left: ${i*UI_arp_tablespacebetween}px"></div>`;
	}
	gridVelo.innerHTML = html;

	/* TIME */
	html = '';
	const gridTime = document.getElementById('UI-arp-row-time');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-time" id="UI-arp-row-time-${i}" style="left: ${i*UI_arp_tablespacebetween}px"></div>`;
	}
	gridTime.innerHTML = html;

	/* RHYTHM */
	html = '';
	const gridRhythm = document.getElementById('UI-arp-row-rhythm');
	for (let i = 1; i < 17; i++) {
	  html += `<div class="UI-text UI-text-arp UI-arp-cell UI-arp-row-rhythm" id="UI-arp-row-rhythm-${i}" style="left: ${i*UI_arp_tablespacebetween}px"></div>`;
	}
	gridRhythm.innerHTML = html;

	let activeCell = null;
	let activeCellStartY = 0;
	let activeCellStartValue = 0;
	let activeCellType = null;

	/* RESET TO NECESSARY VALUES */

	resetArpRow(document.getElementById('UI-arp-row-step'), 'UI-arp-row-step','step', 0);

	document.addEventListener('mousemove', (e) => {
	  if (!activeCell) return;
	  const delta = activeCellStartY - e.clientY;
	  let value;
	  
	  if (activeCellType === 'pan') {
	    value = Math.min(50, Math.max(-51, Math.floor(activeCellStartValue + delta)));
	    if (value < -50) value = "R";
	    activeCell.textContent = value;
	  } else if (activeCellType === 'octave') {
	    value = Math.min(4, Math.max(-5, Math.floor(activeCellStartValue + delta / 10)));
	    if (value < -4) value = "R";
	    activeCell.textContent = value;
	  } else if (activeCellType === 'step') {
	    value = Math.min(8, Math.max(-9, Math.floor(activeCellStartValue + delta / 5)));
	    if (value < -8) value = "R";
	    if (value == 0) value = "X";
	    activeCell.textContent = value;
	  } else if (activeCellType === 'pitch') {
	    value = Math.min(12, Math.max(-13, Math.floor(activeCellStartValue + delta / 5)));
	    if (value < -12) value = "R";
	    activeCell.textContent = value;
	  } else if (activeCellType === 'velo') {
	    value = Math.min(100, Math.max(0, Math.floor(activeCellStartValue - delta)));
	    activeCell.style.opacity = 1 - value / 100.0;
	  } else if (activeCellType === 'time') {
	    value = Math.min(100, Math.max(0, Math.floor(activeCellStartValue - delta)));
	    activeCell.style.opacity = 1 - value / 100.0;
	  } else if (activeCellType === 'rhythm') {
	    value = Math.min(9, Math.max(0, Math.floor(activeCellStartValue + delta / 20)));
	    activeCell.style.backgroundPosition = "0 -"+((9 - value)*25)+"px";
	  }
	});

	document.addEventListener('mouseup', () => { activeCell = null; activeCellType = null; });
	gridPan.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-pan') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'pan';
	});
	gridOctave.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-octave') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'octave';
	});
	gridVelo.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-velo') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'velo';
	});
	gridPitch.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-pitch') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'pitch';
	});
	gridStep.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-step') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'step';
	});
	gridTime.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-time') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'time';
	});
	gridRhythm.addEventListener('mousedown', (e) => {
	  if (!e.target.classList.contains('UI-arp-row-rhythm') || audioPlaying > -1) return;
	  activeCell = e.target;
	  activeCellStartY = e.clientY;
	  activeCellStartValue = parseInt(activeCell.textContent) || 0;
	  activeCellType = 'rhythm';
	});

	document.addEventListener('click', (e) => {
	  if (!e.metaKey || audioPlaying > -1) return;
	  if (e.target.classList.contains('UI-arp-row-pan')) e.target.textContent = 0;
	  else if (e.target.classList.contains('UI-arp-row-octave')) e.target.textContent = 0;
	  else if (e.target.classList.contains('UI-arp-row-step')) e.target.textContent = 0;
	  else if (e.target.classList.contains('UI-arp-row-pitch')) e.target.textContent = 0;
	  else if (e.target.classList.contains('UI-arp-row-velo')) e.target.style.opacity = 0.6;
	  else if (e.target.classList.contains('UI-arp-row-time')) e.target.style.opacity = 0.6;
	  else if (e.target.classList.contains('UI-arp-row-rhythm')) e.target.style.backgroundPosition = "0 -200px";
	});
}




/*
///////////////////////////////////////////////////////////////////
///// DOCUMENT READY
///////////////////////////////////////////////////////////////////
*/



$(document).ready(function() {
	initUIData();
	updateUIScale();
	window.addEventListener('resize', updateUIScale);
	preloadCircle();
	if(document.getElementById('UI-arp-row-numbers'))
		loadArpGrid();
	hideUnnecessaryElements();
	updateGUIInfo();
	mixerDefault();
});
